var _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#FF3C3C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36.3536,
    y1: 7.35355,
    x2: 7.35356,
    y2: 36.3535,
    stroke: "#FF3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledJob);
export default __webpack_public_path__ + "static/media/cancelledJob.fa4591bf0064ae759a3703f629f367a2.svg";
export { ForwardRef as ReactComponent };